import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

const PWAHeader = ({ title, onBack }) => {



  const navigate = useNavigate();
  const isAndroidWebView = () => {
    return typeof window.Android !== 'undefined'; // agar WebView se call ho raha hoga to `window.Android` defined hoga
  };
  const handleBackButtonPress = () => {


    if (isAndroidWebView()) {
      console.log('Android WebView detected!');
      if (window.Android) {
        window.Android.onBackPressed();
      } else if (onBack) {
        onBack();
      } else {
        navigate(-1);
      }
    } else {
      console.log('Laptop Browser detected!');
      window.history.back();
    }


  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px 16px",
        background: "linear-gradient(90deg, #fff 0%, rgba(255, 152, 0, 0.11) 70%)",
        borderBottom: "1px solid #ddd",
      }}
    >
      <ArrowBackIosIcon sx={{ cursor: "pointer", color: "#771615" }} onClick={handleBackButtonPress} />
      <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center", color: "#771615" }}>
        {title || "Log Food"}
      </Typography>
    </Box>
  );
};

export default PWAHeader;